import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=1f76b8ce&scoped=true"
import script from "./Profil.vue?vue&type=script&lang=ts"
export * from "./Profil.vue?vue&type=script&lang=ts"
import style0 from "./Profil.vue?vue&type=style&index=0&id=1f76b8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76b8ce",
  null
  
)

export default component.exports